import React from "react";

/**
 * MiseLogo — inline SVG wordmark. Warm off-white letterforms with a muted
 * orange "i" (stroke + dot). Sized via className / height; width auto-scales
 * from the viewBox aspect ratio (200 × 83 → ~2.41:1).
 */
const MiseLogo = ({ className = "h-6 w-auto", title = "Mise", ...rest }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="237 195 200 83"
    role="img"
    aria-label={title}
    className={className}
    {...rest}
  >
    <title>{title}</title>
    <g transform="translate(252,0) scale(0.95,1) translate(-252,0)">
      <text
        x="252"
        y="263"
        fill="#F4EFE6"
        fontSize="72"
        fontWeight="700"
        fontFamily="Arial, Helvetica, sans-serif"
      >
        M
      </text>
    </g>
    <rect x="314" y="226" width="10.5" height="37" fill="#F2701C" />
    <circle cx="319.25" cy="215" r="4.8" fill="#F2701C" />
    <text
      x="330"
      y="263"
      fill="#F4EFE6"
      fontSize="72"
      fontWeight="700"
      fontFamily="Arial, Helvetica, sans-serif"
    >
      S
    </text>
    <text
      x="378"
      y="263"
      fill="#F4EFE6"
      fontSize="72"
      fontWeight="700"
      fontFamily="Arial, Helvetica, sans-serif"
    >
      E
    </text>
  </svg>
);

export default MiseLogo;
